<script setup lang="ts">
/**
 * Surface container. Reduced padding on small screens so list cards stay
 * dense; desktop gets more breathing room.
 */
import { computed, useAttrs } from 'vue'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/shared/lib/cn'

const card = cva('rounded-lg border border-border bg-card text-card-foreground shadow-sm', {
  variants: {
    padding: {
      none: '',
      sm: 'p-3 md:p-4',
      md: 'p-4 md:p-6',
      lg: 'p-6 md:p-8',
    },
  },
  defaultVariants: { padding: 'md' },
})

interface Props {
  padding?: VariantProps<typeof card>['padding']
}

const props = withDefaults(defineProps<Props>(), { padding: 'md' })
const attrs = useAttrs()
const classes = computed(() => cn(card({ padding: props.padding }), (attrs.class as string) ?? ''))
</script>

<template>
  <div :class="classes">
    <slot />
  </div>
</template>
